import logoSvg from '@/assets/icons/app/logo.svg'
export const isAbsoluteUri = (uri) => {
  return (/^https?:\/\//).test(uri)
}
export const isWxworkBrowser = () => {
  const ua = window.navigator.userAgent
  return ua.includes('wxwork')
}
export const isSafariBrowser = () => {
  const ua = window.navigator.userAgent
  return ua.includes('Safari')
}
export function openLink(url, isBlank = true, iswxWorkForce = true) {
  const isSafari = isSafariBrowser()
  const isWxwork = isWxworkBrowser()
  const isLocalDev = location.origin.includes('localhost') || location.origin.includes('127.0.0.1')
  // 不打开新窗口
  if (!isBlank || ((isWxwork || isLocalDev) && !iswxWorkForce)) {
    return location.href = url
  }
  // 需要打开新窗口
  if (isSafari) {
    const blankAEl = document.createElement('a')
    blankAEl.setAttribute('target', '_blank')
    blankAEl.setAttribute('href', url)
    blankAEl.click()
  }
  else {
    window.open(url)
  }
}
export function setWebIcon(img) {
  document.querySelector('link[rel="icon"]').setAttribute('href', img)
}
export function setWebTitle(title) {
  document.title = title
}
export function setBaseWebInfo() {
  setWebIcon(logoSvg)
  setWebTitle('加载中...')
}
export function reLoadWeb() {
  location.reload()
}
